import axios from '@_system/axios/axios.js'
const modulesFiles = require.context('./api', true, /.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
	const moduleName = modulePath.replace(/\.\/(.*)\.js/, '$1')
	const value = modulesFiles(modulePath)
	modules[moduleName] = value.default
	return modules
}, {})
export default {
	commonApi(path) {
		return {
			list(data = {}) {
				return new Promise((resolve, reject) => {
					axios.get(path, data, (res) => {
						resolve(res.data)
					}, reject)
				})
			},
			save(data = {}) {
				return new Promise((resolve, reject) => {
					axios.post(path, data, (res) => {
						resolve(res.data)
					}, reject)
				})
			},
			get(id, data = {}) {
				return new Promise((resolve, reject) => {
					axios.get(path + '/' + id, data, (res) => {
						resolve(res.data)
					}, reject)
				})
			},
			update(id, data = {}) {
				return new Promise((resolve, reject) => {
					axios.put(path + '/' + id, data, (res) => {
						resolve(res.data)
					}, reject)
				})
			},
			delete(id, data = {}) {
				return new Promise((resolve, reject) => {
					axios.delete(path + '/' + id, data, (res) => {
						resolve(res.data)
					}, reject)
				})
			},
			updateImgAttributes(data = {}) {
				return new Promise((resolve, reject) => {
					axios.post(path + '/updateImgAttributes', data, (res) => {
						resolve(res.data)
					}, reject)
				})
			},
			updatefromlist(id,data = {}) {
				return new Promise((resolve, reject) => {
					axios.post(path + '/updatefromlist/'+ id, data, (res) => {
						resolve(res.data)
					}, reject)
				})
			},			
			import(data = {}) {
				return new Promise((resolve, reject) => {
					axios.post(path + '/import', data, (res) => {
						resolve(res.data)
					}, reject)
				})
			},
			export (data = {}) {
				return new Promise((resolve, reject) => {
					axios.post(path + '/export', data, (res) => {
						resolve(res.data)
					}, reject)
				})
			},
			init(data = {}) {
				return new Promise((resolve, reject) => {
					axios.get('moduleConfig/' + window.config.app + path, data, (res) => {
						resolve(res.data)
					}, reject, true)
				})
			},
		}
	},
	login(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post('/login', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	dingtalklogin(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post('/dingtalklogin', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	wecomlogin(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post('/wecomlogin', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	isLogin(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post('/isLogin', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	changecompany(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post('/changecompany', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	changePassword(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post('/changePassword', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	getVerificatCode(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post('/getVerificatCode', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	getjssdkcinfig(data = {}) {
		return new Promise((resolve) => {
			axios.post('h5/getjssdkcinfig', data, (res) => {
				resolve(res.data)
			})
		})
	},
	...modules

}